import * as Yup from 'yup';

const schemaRHFDemo = Yup.object()
    .shape({
        name: Yup.string()
            .required('Name is required')
            .min(2, 'Min length is 2'),
        email: Yup.string()
            .email('Invalid Email')
            .required('E-mail is required!'),
        country: Yup.string()
            .required('Country is required!'),
        number: Yup.number()
            .min(0, 'Min is 0')
            .max(20, 'Max is 20'),

    })
    .required();

export default schemaRHFDemo